import React from 'react';
import { ChevronBackward, ChevronForward } from '@naf-simba/building-blocks-icons/Arrows';
import { mapSimbaIconButtonVariant } from '@utils/simba';
import * as S from '../Styles';

type ScrollDirection = 'left' | 'right';

interface ScrollButtonProps {
  direction: ScrollDirection;
  onClick: () => void;
  isDisabled: boolean;
}

export const ScrollButton: React.FC<ScrollButtonProps> = ({ direction, onClick, isDisabled }) =>
  direction === 'left' ? (
    <S.StyledArrowLeft
      icon={ChevronBackward}
      color={mapSimbaIconButtonVariant('secondary').color}
      variant={mapSimbaIconButtonVariant('secondary').variant}
      aria-label="pil venstre"
      onClick={onClick}
      disabled={isDisabled}
    />
  ) : (
    <S.StyledArrowRight
      icon={ChevronForward}
      color={mapSimbaIconButtonVariant('secondary').color}
      variant={mapSimbaIconButtonVariant('secondary').variant}
      aria-label="pil høyre"
      onClick={onClick}
      disabled={isDisabled}
    />
  );
